<template>
  <div :class="$style.charge">
    <div :class="$style.title">
      <i class="iconfont yw-xiangzuo" @click="back"></i>
      <span>请选择支付方式</span>
    </div>
    <div :class="$style.price" v-if="!largeChargeFlag">
      支付
      <span>{{ currentGoods.price }}元</span>
    </div>
    <!-- 大额支付并且不是王者重生游戏，可任意输入金额 -->
    <div v-if="largeChargeFlag && !wzcsGames" :class="$style.largeChargePrice">
      <p :class="$style.chargeTitle">请输入金额</p>
      <Field v-model.trim="largePrice" type="number" :class="$style.field"></Field>
      <p :class="$style.tips">支付宝充值范围：10,000-1,000,000</p>
      <p :class="$style.tips">微信充值范围：10,000-500,000</p>
    </div>
     <!-- 大额支付并且是王者重生游戏，只能选固定金额 -->
    <div v-if="largeChargeFlag && wzcsGames" :class="$style.largeChargePrice">
      <p :class="$style.chargeTitle">请选择充值金额</p>
      <div :class="$style.amountTags">
        <span :class="largePrice === item ? $style.active : ''" v-for="(item, index) in amountList" :key="`${index}`" @click="largePrice = item">{{ item }}</span>
      </div>
    </div>
    <!-- 大额支付并且不是王者重生游戏(暂时只有赤焰)，需要选择到账类型 -->
    <div v-if="largeChargeFlag && !wzcsGames" :class="$style.largeChargeScene">
      <p>请选择到账道具</p>
      <RadioGroup v-model="is_charm" direction="horizontal">
        <Radio :name="1" checked-color="#CC1109" icon-size="16">灵符</Radio>
        <Radio :name="0" checked-color="#CC1109" icon-size="16">钻石</Radio>
      </RadioGroup>
    </div>
    <div :class="$style.info">
      <p>
        <span>充值游戏：</span>
        <span>{{ game }}</span>
      </p>
      <p>
        <span>充值区服：</span>
        <span :class="$style.fontBlue">{{ bindRoleInfo.server_name }}</span>
      </p>
      <p>
        <span>充值角色：</span>
        <span :class="$style.fontBlue">{{ bindRoleInfo.role_name }}</span>
      </p>
      <p v-if="!largeChargeFlag">
        <span>充值道具：</span>
        <span :class="$style.fontYellow">{{ `${largePrice}元道具` || currentGoods.name }}</span>
      </p>
    </div>
    <div :class="$style.payType">
      <p>支付方式：</p>
      <RadioGroup v-model="payType">
        <ul>
          <li>
            <div>
              <img :src="`${$cdnUrl}/offlinePay/drawable-xxhdpi/weixin.png`" alt />
              <span>微信支付</span>
            </div>
            <Radio :name="0" checked-color="#CC1109"></Radio>
          </li>
          <li>
            <div>
              <img :src="`${$cdnUrl}/offlinePay/drawable-xxhdpi/zhifubao.png`" alt />
              <span>支付宝支付</span>
            </div>
            <Radio :name="1" checked-color="#CC1109"></Radio>
          </li>
        </ul>
      </RadioGroup>
    </div>
    <Button @click="toCharge" :class="$style.submit">立即支付</Button>
    <div :class="$style.hint" v-show="hintShow" @click="hintShow = false"></div>
    <div :class="$style.checkOrder" v-if="confirmVisible">
      <div :class="$style.content">
        <i class="iconfont yw-guanbi2" @click="closeConfirm"></i>
        <p>请确认微信支付是否已完成？</p>
        <p @click="closeConfirm">已完成支付</p>
        <p @click="closeConfirm">支付遇到问题，重新支付</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { RadioGroup, Radio, Button, Field } from 'vant';
import { isWeiXin, sort_ASCII } from '@/libs/utils';
import { officialAccountsPay, getPayTypeNew, PAY_URL, checkOrder as checkOrderApi } from '@/api/pay';
import { wzcsGames } from '@/config/offlinePayGame';

export default {
  name: '',
  data() {
    return {
      payType: 0,
      aliPayType: {},
      wxPayType: {},
      hintShow: false,
      confirmVisible: false,
      order_sn: '',
      largePrice: '',
      is_charm: 1,
      amountList: [10000, 20000]
    };
  },
  mounted() {
    if (!isWeiXin()) this.getPayType();
  },
  computed: {
    ...mapState({
      currentGoods: state => state.offlinePay.currentGoods,
      game: state => state.offlinePay.game,
      gameFlag: state => state.offlinePay.gameFlag,
      bindRoleInfo: state => state.offlinePay.bindRoleInfo,
      appkey: state => state.offlinePay.appkey,
      appId: state => state.offlinePay.appId,
      largeChargeFlag: state => state.offlinePay.largeChargeFlag,
      payTypeInfo: state => state.offlinePay.payTypeInfo,
      largePayTypeInfo: state => state.offlinePay.largePayTypeInfo
    }),
    wzcsGames() {
      return wzcsGames.includes(this.gameFlag);
    }
  },
  components: {
    Button,
    RadioGroup,
    Radio,
    Field
  },
  methods: {
    ...mapActions({
      placeOrder: 'offlinePay/placeOrder'
    }),
    ...mapMutations({
      setOfflinePayState: 'offlinePay/setState'
    }),
    toCharge() {
      if (this.largeChargeFlag) {
        if (!this.largePrice) {
          this.$toast('请输入充值金额');
          return;
        }
        this.setOfflinePayState({
          is_charm: this.wzcsGames ? '' : this.is_charm,
          largePrice: this.largePrice
        });
      }
      if (isWeiXin()) {
        if (!this.payType) {
          this.wxInnerPay();
        } else {
          this.hintShow = true;
        }
      } else {
        this.outerPay();
      }
    },
    async getPayType() {
      const payTypeList = this.largeChargeFlag ? this.largePayTypeInfo : this.payTypeInfo;
      this.aliPayType = payTypeList.find(item => item.img_class_name === 'alipay');
      this.wxPayType = payTypeList.find(item => item.img_class_name === 'wechat');
    },
    async wxInnerPay() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      const {
        content: { order_sn, code }
      } = await this.placeOrder(52);
      if (code) {
        this.handleAnti(code);
        return;
      }
      this.order_sn = order_sn;
      const r = await officialAccountsPay({
        appkey: this.appkey,
        order_sn,
        wx_app_id: this.appId,
        open_id: userInfo.open_id
      });
      const { nonceStr, paySign, timeStamp, signType } = r.content;
      wx.chooseWXPay({
        timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr, // 支付签名随机串，不长于 32 位
        package: r.content.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign, // 支付签名
        success: res => {
          this.checkOrder();
        },
        fail: err => {
          this.checkOrder();
        },
        cancel: () => {
          this.checkOrder();
        }
      });
    },
    handleAnti(code) {
      switch (code) {
        case 4:
          // 游客模式
          this.$toast('当前账号尚未实名认证，无法进行充值和付费消费，请先前往游戏进行实名认证。');
          break;
        case 5:
          // 游客模式
          this.$toast('您目前为未成年人账号，已被纳入防沉迷系统，根据国家新闻出版署《关于防止未成年人沉迷网络游戏的通知》，本游戏不为未满8周岁的用户提供游戏充值服务。');
          break;
        case 6:
          // 小于8岁
          this.$toast('您目前为未成年人账号，已被纳入防沉迷系统，根据国家新闻出版署《关于防止未成年人沉迷网络游戏的通知》，游戏中8周岁以上未满16周岁的用户，单次充值金额不得超过50元人民币，每月充值金额累计不得超过200元人民币。');
          break;
        case 7:
          // 小于8岁
          this.$toast('您目前为未成年人账号，已被纳入防沉迷系统，根据国家新闻出版署《关于防止未成年人沉迷网络游戏的通知》，游戏中16周岁以上未满18周岁的用户，单次充值金额不得超过100元人民币，每月充值金额累计不得超过400元人民币。');
          break;
      }
    },
    async outerPay() {
      const payType = this.payType ? this.aliPayType.pay_type : this.wxPayType.pay_type;
      const {
        content: { order_sn, code }
      } = await this.placeOrder(payType);

      if (code) {
        this.handleAnti(code);
        return;
      }

      const sync_notify_url = `${window.location.origin}${window.location.pathname}?`;
      const params = {
        appkey: this.appkey,
        order_sn: order_sn,
        sync_notify_url: encodeURIComponent(sync_notify_url)
      };
      const sign = sort_ASCII(params);
      const aliUrl = `${PAY_URL}?from_browser=1&appkey=${this.appkey}&order_sn=${order_sn}&sign=${sign}&sync_notify_url=${encodeURIComponent(sync_notify_url)}`;
      window.open(aliUrl, '_self');
    },
    back() {
      this.setOfflinePayState({ chargeVisible: false });
    },
    closeConfirm() {
      this.checkOrder(1);
      this.confirmVisible = false;
    },
    async checkOrder(hasConfirmed) {
      const r = await checkOrderApi({ order_sn: this.order_sn });
      const { confirm, pay_status, order_sn } = r.content;
      if (confirm && !hasConfirmed) {
        this.confirmVisible = true;
        return;
      }
      if (pay_status == 1) {
        this.$toast('支付成功，实际支付结果请以游戏内为准');
        this.setOfflinePayState({ chargeVisible: false });
      } else {
        this.$toast('支付失败，实际支付结果请以游戏内为准');
        this.setOfflinePayState({ chargeVisible: false });
      }
    }
  }
};
</script>

<style lang="scss" module>
.fontBlue {
  color: #5ab7ff;
}
.fontYellow {
  color: #ffa128;
}

.charge {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #ffffff;
  z-index: 10;
  overflow-y: auto;
  padding-bottom: 20px;
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    font-size: 21px;
    width: 100%;
    position: relative;
    border-bottom: 1px solid #f4f4f4;
    :global {
      .iconfont {
        position: absolute;
        left: 10px;
        font-size: 20px;
        color: #666666;
      }
    }
  }
  .price {
    height: 136px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    &::after {
      position: absolute;
      content: ' ';
      left: 20px;
      width: calc(100% - 40px);
      bottom: 0;
      border-bottom: 1px solid #f4f4f4;
    }
    > span {
      font-size: 23px;
      display: inline-block;
      margin-bottom: 4px;
      margin-left: 6px;
    }
  }
  .largeChargePrice {
    font-size: 17px;
    color: #666666;
    font-weight: 500;
    padding: 20px 12px 0 12px;
    .chargeTitle {
      margin-left: 15px;
    }
    .amountTags {
      margin: 5px;
      > span {
        display: inline-block;
        border: 1px solid #7e7d7d;
        padding: 5px 10px;
        margin: 10px;
        border-radius: 4px;
        &.active {
          color: #cc1109;
          border-color: #cc1109;
        }
      }
    }
    .tips {
      font-size: 13px;
      margin: 5px 15px 0 15px;
      color: #979494;
    }
    .field {
      font-weight: normal;
      font-size: 23px;
      margin-bottom: 10px;
      padding: 5px 15px;
    }
  }
  .largeChargeScene {
    padding: 15px 27px 0 27px;
    font-size: 17px;
    color: #666666;
    font-weight: 500;
    > p {
      margin-bottom: 10px;
    }
    :global {
      .van-radio__label {
        font-size: 15px;
        color: #666666;
      }
      .van-radio {
        margin-right: 50px;
      }
    }
  }
  .info {
    padding: 20px 20px 0 20px;
    font-size: 16px;
    color: #666666;
    > p {
      border-bottom: 1px solid #f4f4f4;
      padding: 0 5px 5px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      > span:nth-child(1) {
        font-weight: 500;
        font-size: 17px;
      }
    }
  }
  .payType {
    padding: 0 25px;
    > p {
      font-size: 17px;
      color: #666666;
      font-weight: 500;
      margin-bottom: 25px;
    }
    ul {
      > li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 15px;
        color: #666666;
        margin-bottom: 25px;
        > div {
          display: flex;
          align-content: center;
        }
        img {
          display: inline-block;
          width: 19px;
          height: 19px;
          margin-right: 8px;
        }
      }
    }
  }
  .submit {
    width: 270px;
    height: 52px;
    border: 6px;
    color: #ffffff;
    background: #cc1109;
    display: block;
    margin: auto;
    margin-top: 90px;
  }
  .hint {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    background-image: url('//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/tips.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .checkOrder {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.6);
    .content {
      position: relative;
      background: #ffffff;
      display: inline-block;
      border-radius: 8px;
      padding: 10px 0 0 0;
      :global {
        .yw-guanbi2 {
          position: absolute;
          top: 5px;
          right: 5px;
        }
      }
      > p {
        padding: 10px 25px;
        text-align: center;
      }
      > p:nth-child(2) {
        padding-bottom: 10px;
        border-bottom: 1px solid #dddddd;
      }
      > p:nth-child(3) {
        color: rgb(238, 78, 78);
        border-bottom: 1px solid #dddddd;
      }
      > p:nth-child(4) {
        color: #130404;
        font-size: 12px;
      }
    }
  }
}
</style>
